import { render, staticRenderFns } from "./mycustomer.vue?vue&type=template&id=c2a4f78c&scoped=true&"
import script from "./mycustomer.vue?vue&type=script&lang=js&"
export * from "./mycustomer.vue?vue&type=script&lang=js&"
import style0 from "./mycustomer.vue?vue&type=style&index=0&id=c2a4f78c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a4f78c",
  null
  
)

export default component.exports